import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import screenprintingprocess1 from '../Images/ScreenPrintingProcess-1.jpeg';
import screenprintingprocess2 from '../Images/ScreenPrintingProcess-2.jpeg';
import WaterDecal from '../Images/WaterDecal.jpeg'
import ThermalDecalPrintingImage from '../Images/ThermalDecalPrinting.webp';
import CompanyName from '../Component/CompanyName';

const ScreenPrinting = () => {
  return (
    <>
    <article className="pt-8 max-w-[1200px] mx-auto px-8">
      <title>Screen Printing</title>
      <header className="mb-8 ">
        <h1 className="text-3xl font-bold mb-4">Premium Screen Printing Services</h1>
        <p className="text-lg">
          Elevate your products with our advanced screen printing technology, delivering exceptional quality across diverse materials.
        </p>
      </header>

      <section className="mb-12 ">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Artistic Precision for Every Surface</h2>
            <p className="mb-4 text-gray-700">
              At <CompanyName/>, we combine cutting-edge screen printing technology with artistic expertise to produce exquisite artwork and intricate designs. Our capabilities range from delicate 1mm details to expansive 70 x 100 cm formats.
            </p>
            <p className="mb-4 text-gray-700">
              We specialize in printing on diverse substrates including posters, watch faces, glass, wood, ceramics, metals, and cosmetic packaging. Each project receives meticulous attention to color gradation, texture, and durability.
            </p>
            <Link href="/services/direct-to-product" className="text-blue-600 hover:underline">
              Explore our Direct-to-Product Printing →
            </Link>
          </div>
          <div className="">
            {/* Image placeholder for screen printing process */}
            <img src={screenprintingprocess1} alt='' title='' className='border-4 border-white rounded-lg'/>
          
          </div>
        </div>
      </section>

      <section className="mb-12  ">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Technical Specifications</h2>
        <TableContainer component={Paper} className="shadow-sm">
          <Table aria-label="Screen printing specifications">
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row" className="font-semibold">Print Size Range</TableCell>
                <TableCell>1mm to 70 x 100cm</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" className="font-semibold">Supported Materials</TableCell>
                <TableCell>Paper, Fabric, Glass, Wood, Ceramics, Metals, Plastics</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" className="font-semibold">Color Capabilities</TableCell>
                <TableCell>Full CMYK + Pantone spot colors</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" className="font-semibold">Mesh Types</TableCell>
                <TableCell>Polyester, Metal, Thermal (nylon and stainless steel available)</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row" className="font-semibold">Related Services</TableCell>
                <TableCell>
                  <Link href="/services/water-transfer" className="text-blue-600 hover:underline mr-4">Water Transfer</Link>
                  <Link href="/services/thermal-transfer" className="text-blue-600 hover:underline mr-4">Thermal Transfer</Link>
                  <Link href="/services/adhesive-printing" className="text-blue-600 hover:underline">Adhesive Printing</Link>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </section>

      <section className="mb-12 ">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">The Screen Printing Process</h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <p className="mb-4 text-gray-700">
              Screen printing utilizes a mesh screen to transfer ink onto substrates, with impermeable areas blocked by a stencil. Our technicians expertly maneuver a squeegee in precise motions to fill mesh openings with ink, then transfer it to your material with perfect registration.
            </p>
            <p className="mb-4 text-gray-700">
              For multi-color designs, we employ sequential screens - each aligned with micron precision. While traditionally using silk screens, we now utilize advanced synthetic filaments in polyester, metal, and thermal mesh varieties. Mesh selection (determined by thread count and material) critically impacts final print quality.
            </p>
          </div>
         <div className="">
            {/* Image placeholder for screen printing process */}
            <img src={screenprintingprocess2} alt='' title='' className='border-4 border-white rounded-lg'/>
          
          </div>
        </div>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 ">Advanced Applications</h2>
        <p className="mb-6 text-gray-700 ">
          Beyond traditional printing, our screen printing technology enables sophisticated applications including:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 ">
          <li>Conductive material deposition for circuit printing</li>
          <li>Resistor integration in multi-layer ceramic substrates</li>
          <li>Precision decorative elements for luxury packaging</li>
          <li>Durable industrial labeling solutions</li>
        </ul>

        <div className=''><Link to="/services/circuit-printing" className="text-blue-600 hover:underline">
          Learn about our Circuit Printing Services →
        </Link></div>
      </section>

      <section className="bg-white p-8 rounded-lg ">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Water Decal Application Guide</h2>
        <p className="mb-4 text-gray-700">
          Our complimentary water decals (included with ILMP orders) offer an effortless way to achieve professional nail art. These water-activated transfers create intricate designs without requiring artistic skill.
        </p>
        
        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Materials Needed:</h3>
        <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
          <li>Water decal sheet (provided)</li>
          <li>Bow of water</li>
          <li>Tweezers</li>
          <li><Link href="/products/littmuss-crystal-top-coat" className="text-blue-600 hover:underline">Littmuss Crystal Top Coat</Link></li>
          <li><Link href="/products/moraze-delicate-white" className="text-blue-600 hover:underline">Moraze Delicate White polish</Link> (or base color of choice)</li>
        </ul>

        <div className="grid md:grid-cols-2 gap-8 mb-6">
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Application Steps:</h3>
            <ol className="list-decimal pl-6 text-gray-700 space-y-3">
              <li>Apply two coats of base polish and allow to dry completely</li>
              <li>Cut decal to approximate nail size (precision not required)</li>
              <li>Immerse decal in water for 10-20 seconds using tweezers</li>
              <li>Gently separate paper backing from design</li>
              <li>Position wet decal on nail and smooth from center outward</li>
              <li>Seal with <Link href="/products/littmuss-crystal-top-coat" className="text-blue-600 hover:underline">Littmuss Crystal Top Coat</Link></li>
            </ol>
          </div>
         <div className="w-1/2">
            {/* Image placeholder for screen printing process */}
            <img src={WaterDecal} alt='' title='' className='border-4 border-white rounded-lg'/>
          
          </div>
        </div>

        <div className="bg-yellow-50 p-4 rounded border border-yellow-200">
          <h4 className="font-semibold text-gray-800 mb-2">Pro Tips:</h4>
          <ul className="list-disc pl-6 text-gray-700 space-y-1">
            <li>Re-wet decal if backing proves difficult to remove</li>
            <li>Use <Link href="/products/moraze-cosmic-fusion" className="text-blue-600 hover:underline">Moraze Cosmic Fusion</Link> for easy decal removal</li>
            <li>Store unused decals in cool, dry conditions</li>
          </ul>
        </div>

        <p className="mt-6 text-gray-700">
          Discover our full collection of <Link href="/products/nail-decals" className="text-blue-600 hover:underline">nail art decals</Link> for endless creative possibilities.
        </p>
      </section>

        

    </article>
<div className="rounded-lg flex items-center justify-center my-8">
          {/* Image placeholder for advanced applications */}
          <img src={ThermalDecalPrintingImage} alt='' title='' className=''/>
        </div>
    </>
  );
};

export default ScreenPrinting;